import { MILLISECONDS_UNTIL_POST_IS_OLD } from '@/shared/constants/newPosts';
import type { PostBadgeEntry } from '@/shared/store/useBadgeStore';

type NewPostCandidate = {
  postId?: string;
  created?: number;
  creator?: { id?: string };
};

export const countNewPosts = (
  posts: NewPostCandidate[] | undefined,
  readPostBadgeEntries: PostBadgeEntry[],
  ownUserId?: string
): number => {
  if (!posts) return 0;
  const deadline = Date.now() - MILLISECONDS_UNTIL_POST_IS_OLD;
  return posts.filter((post) => {
    const isRecentlyCreated = (post.created ?? 0) > deadline;
    const isUnread = !readPostBadgeEntries.some(
      (entry) => entry.id === post.postId
    );
    const isNotOwnPost = post.creator?.id !== ownUserId;
    return isRecentlyCreated && isUnread && isNotOwnPost;
  }).length;
};
